// 获取新闻详情
export const GETNEWSDETAILS = 'get-news-details'

// 获取推荐新闻
export const GETRECOMMENDNEWS = 'get-recommend-news'

// 获取相关新闻
export const GETRELATEDNEWS = 'get-related-news'

// 获取专题详情
export const GETFEATUREDETAILS = 'get-feature-details'

// 获取更多专题列表
export const GETMOREFEATURE = 'get-more-feature'

export const GETADIMPLANT = 'get-ad-implant'

export const GETNEWSLIST = 'get-news-list'

export const GETHOTNEWSVIDEO = 'get-hot-news-video'
